import { TeamSide } from '@collector/shared-domain'
import { Coordinates } from '@collector/shared-ui-domain'
import PossessionAwayDangerousAttack from '@collector/shared-ui-domain/assets/rugby/possession-away-dangerous-attack.svg'
import PossessionAwayDefault from '@collector/shared-ui-domain/assets/rugby/possession-away-default.svg'
import PossessionAwayInPossession from '@collector/shared-ui-domain/assets/rugby/possession-away-in-possession.svg'
import PossessionHomeDangerousAttack from '@collector/shared-ui-domain/assets/rugby/possession-home-dangerous-attack.svg'
import PossessionHomeDefault from '@collector/shared-ui-domain/assets/rugby/possession-home-default.svg'
import PossessionHomeInPossession from '@collector/shared-ui-domain/assets/rugby/possession-home-in-possession.svg'

export const FIELD_LENGTH = 100
const SVG_WIDTH = 250
const ratio = FIELD_LENGTH / SVG_WIDTH
export const TRY_AREA_X_COORDINATE_THRESHOLD = 21 * ratio
export const RED_ZONE_X_COORDINATE_THRESHOLD = 42 * ratio
export const LINE_THRESHOLD = 1 * ratio

export function isWithinRedZones(coordinateX: Coordinates['x']): boolean {
  return (
    coordinateX <=
      FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD + LINE_THRESHOLD / 2 &&
    coordinateX >=
      FIELD_LENGTH -
        TRY_AREA_X_COORDINATE_THRESHOLD -
        RED_ZONE_X_COORDINATE_THRESHOLD
  )
}

export function isWithinRedZone(
  teamSide: TeamSide,
  coordinateX: Coordinates['x'],
): boolean {
  if (teamSide === 'home')
    return (
      coordinateX >=
        FIELD_LENGTH -
          TRY_AREA_X_COORDINATE_THRESHOLD -
          RED_ZONE_X_COORDINATE_THRESHOLD &&
      coordinateX <=
        FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD + LINE_THRESHOLD / 2
    )

  return (
    FIELD_LENGTH - coordinateX <=
      FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD + LINE_THRESHOLD / 2 &&
    FIELD_LENGTH - coordinateX >=
      FIELD_LENGTH -
        TRY_AREA_X_COORDINATE_THRESHOLD -
        RED_ZONE_X_COORDINATE_THRESHOLD
  )
}

export function isWithinTryArea(
  teamSide: TeamSide,
  coordinateX: Coordinates['x'],
): boolean {
  if (teamSide === 'home') {
    return (
      coordinateX >=
      FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
    )
  } else {
    return coordinateX <= TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
  }
}

export function isWithinTryAreas(coordinateX: Coordinates['x']): boolean {
  return (
    coordinateX <= TRY_AREA_X_COORDINATE_THRESHOLD ||
    coordinateX >=
      FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
  )
}

export function defaultCoordinatesTransform(
  coordinates: Coordinates,
  teamSide: TeamSide,
): Coordinates {
  let x: number
  if (!isWithinTryAreas(coordinates.x)) {
    x = coordinates.x
  } else {
    x =
      teamSide === 'home'
        ? TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
        : FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
  }
  const y = coordinates.y

  return { x, y }
}

export function getBallContestPossessionSvg(
  coordinate?: Coordinates['x'],
  isAway?: boolean,
): string {
  if (coordinate === undefined)
    return isAway ? PossessionAwayDefault : PossessionHomeDefault
  const teamSide = isAway ? 'away' : 'home'
  if (isWithinRedZone(teamSide, coordinate))
    return isAway
      ? PossessionAwayDangerousAttack
      : PossessionHomeDangerousAttack

  return isAway ? PossessionAwayInPossession : PossessionHomeInPossession
}

export function getInPossessionPossessionSvg(
  coordinate?: Coordinates['x'],
  isAway?: boolean,
): string {
  if (coordinate === undefined)
    return isAway ? PossessionAwayDefault : PossessionHomeDefault
  const teamSide = isAway ? 'away' : 'home'
  if (isWithinTryArea(teamSide, coordinate))
    return isAway
      ? PossessionAwayDangerousAttack
      : PossessionHomeDangerousAttack
  return isAway ? PossessionAwayInPossession : PossessionHomeInPossession
}
